// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iJeO6g_QH142iGHNrUvK{border-radius:4px;width:100%}.HZmja59p2cl3oBrnmcXK{cursor:pointer;background:var(--background-neutral-default);border-radius:6px;align-items:center;gap:12px;padding:16px;display:flex}.PKliAeovxNYKfc60PKl0{padding:10px}.sQm0HAYtq1kKFCQc1GW2{margin-left:auto}.nj9gDP2ARSAP0BRo23vb{background:var(--background-primary-inverted-primary)}.nj9gDP2ARSAP0BRo23vb.lQXNW3Uss2Qw0PGjabig{background:var(--background-neutral-default)}.nj9gDP2ARSAP0BRo23vb:hover{background:var(--background-neutral-subtle)}.cI3uX0I2CUY1qysYoewJ.lQXNW3Uss2Qw0PGjabig{background:var(--light-blue-10);color:var(--light-blue-100)}.k63s5AlvDobChzpyrlix{background:0 0}.k63s5AlvDobChzpyrlix:hover{background:var(--background-neutral-subtle)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `iJeO6g_QH142iGHNrUvK`,
	"header": `HZmja59p2cl3oBrnmcXK`,
	"content": `PKliAeovxNYKfc60PKl0`,
	"toggleIcon": `sQm0HAYtq1kKFCQc1GW2`,
	"withHover": `nj9gDP2ARSAP0BRo23vb`,
	"isOpen": `lQXNW3Uss2Qw0PGjabig`,
	"isActive": `cI3uX0I2CUY1qysYoewJ`,
	"transparent": `k63s5AlvDobChzpyrlix`
};
export default ___CSS_LOADER_EXPORT___;
